<template>
  <div v-if="Object.entries(bien).length > 0"
       class="col">
    <div class="row center justify-content-between mt-4">
      <div id="toPrint"
           class="col-12 col-lg-9 px-0">
        <ul id="timeLineBar"
            class="d-flex flex-row align-items-center list-unstyled border-bottom border-secondary m-0 w-100">
          <li>
            <router-link class="text-dark"
                         :to="{ name: 'Achat', params: {typeSearched: 'bien'} }">
              Achat
            </router-link>
          </li>
          <li>
            <router-link class="text-dark"
                         :to="{ name: 'Achat', params: {typeSearched: this.$options.filters.camelCase(bien.d_type)} }">
              {{ bien.d_type }}
            </router-link>
          </li>
          <li>
            <p class="d-inline-block openSans-bold text-dark m-0">Réf.{{ bien.d_reference }}</p>
          </li>
        </ul>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex flex-column">
            <p class="openSans-bold mb-0 mt-3">Réf : {{ bien.d_reference }}</p>
            <p class="openSans-bold text-secondary text-uppercase">{{ bien.d_titre }}</p>
          </div>
          <h4 class="h4 text-primary openSans-bold bg-dark px-5 py-2 m-0">{{ bien.d_prix | formatMoney }} € FAI</h4>
        </div>
        <div id="bien" class="row center mb-5">
          <bien-photos-gallery :photos="photos"></bien-photos-gallery>
          <div class="col-12 infosLogo border-bottom border-secondary px-0 my-3">
            <ul class="list-unstyled d-flex flex-row">
              <li v-if="bien.d_type !== ''">
                <img src="../../assets/images/picto-maison.svg"
                     alt="picto maison">
                <p class="openSans-bold m-0 overflow-auto">{{ bien.d_type }}</p>
              </li>
              <li v-if="bien.d_nbrPieces !== ''">
                <img src="../../assets/images/picto-nbre-pieces.svg"
                     alt="picto pièces">
                <p class="openSans-bold m-0 overflow-auto">{{ bien.d_nbrPieces }} pièces</p>
              </li>
              <li v-if="bien.d_nbrChambres !== ''">
                <img src="../../assets/images/picto-nbre-chambres.svg"
                     alt="picto chambres">
                <p class="openSans-bold m-0 overflow-auto">{{ bien.d_nbrChambres }} chambres</p>
              </li>
              <li v-if="bien.d_surface !== ''">
                <img src="../../assets/images/picto-nbre-surface.svg"
                     alt="picto surface">
                <p class="openSans-bold m-0 overflow-auto">Surface de {{ bien.d_surface }}</p>
              </li>
              <li v-if="bien.d_surfaceTerrain !== ''">
                <img src="../../assets/images/picto-nbre-terrain.svg"
                     alt="picto surface terrain">
                <p class="openSans-bold m-0 overflow-auto">Terrain de {{ bien.d_surfaceTerrain }}</p>
              </li>
            </ul>
          </div>
          <div class="col-12 pl-0">
            <p class="openSans-bold text-secondary text-uppercase">Description du bien</p>
            <p v-html="bien.d_descriptif"></p>
          </div>
          <DPE :bien="bien"></DPE>
          <div class="col-12 col-lg-4 px-0">
            <p v-if="bien.d_descriptifComp !==''"
               class="openSans-bold text-secondary text-uppercase text-nowrap">Informations complémentaires</p>
            <p>{{ bien.d_descriptifComp }}</p>
          </div>
        </div>
      </div>
      <div class="bgGreyPoints col-8 offset-2 col-lg-3 offset-lg-0 pl-4 pr-0 mb-5">
        <ul id="buttonBar"
            class="list-unstyled mt-5">
          <li>
            <bien-alert-email :bien="bien"></bien-alert-email>
          </li>
          <li>
            <b-button squared
                      :href="mailTo"
                      class="share-btn d-flex w-100 mb-3 mt-2"
                      variant="outline-secondary">
              <div class="d-inline ml-4 mr-3 my-auto">
                <PictoNetwork>
                </PictoNetwork>
              </div>
              Partager par mail
              <div class="d-inline ml-auto mr-5 my-auto">
                <PictoArrow orientation="droite">
                </PictoArrow>
              </div>
            </b-button>
          </li>
          <li>
            <b-button squared
                      @click="imprimer"
                      class="print-btn d-flex w-100 mb-3 mt-2"
                      variant="outline-secondary">
              <div class="d-inline ml-4 mr-3 my-auto">
                <PictoPrint>
                </PictoPrint>
              </div>
              Imprimer la fiche
              <div class="d-inline ml-auto mr-5 my-auto">
                <PictoArrow orientation="droite">
                </PictoArrow>
              </div>
            </b-button>
          </li>
        </ul>
        <div class="bg-secondary px-3 px-xl-5 py-4">
          <h2 class="text-light text-uppercase text-center openSans-bold">cette offre vous intéresse ?</h2>
          <div class="d-flex justify-content-center">
            <PictoArrow>
            </PictoArrow>
          </div>
          <b-button squared
                    href="tel:+33561862927"
                    variant="dark"
                    class="text-primary text-uppercase d-block w-100 my-3">
            Appeler
          </b-button>
          <b-button squared
                    href="mailto:contact@tolus-immo.com"
                    variant="dark"
                    class="text-primary text-uppercase d-block w-100">
            Contacter
          </b-button>
        </div>
        <div
             class="calculate-card border border-dark d-flex flex-column align-items-center justify-content-center openSans-bold mt-3">
          <Simulateur>
          </Simulateur>
        </div>
        <div class="bg-GreyPoints h-auto">
        </div>
      </div>
    </div>
    <div v-if="Object.entries(biensAnnexes).length > 0"
         class="row center">
      <h1 class="text-dark text-center openSans-bold">Autres annonces correspondant à votre recherche</h1>
      <div class="list-unstyled d-flex flex-column flex-sm-row justify-content-center w-100 my-5">
        <bien-preview v-for="(bien, idx) in biensAnnexes" :key="idx" :bien="bien"></bien-preview>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import DataApi from 'fm-data-api'
import { ButtonPlugin, ModalPlugin } from 'bootstrap-vue'
import { getImage } from '../../mixins/getImage'
import DPE from '../../components/DPE.vue'

Vue.use(ButtonPlugin)
Vue.use(ModalPlugin)

export default {
  name: 'Bien',
  components: {
    Simulateur: () => import("../../components/Simulateur"),
    PictoArrow: () => import("../../components/PictoArrow"),
    PictoNetwork: () => import("../../components/PictoNetwork"),
    PictoPrint: () => import("../../components/PictoPrint"),
    BienPreview: () => import("../../components/BienPreview.vue"),
    BienPhotosGallery: () => import("../../components/BienPhotosGallery.vue"),
    BienAlertEmail: () => import("../../components/BienAlertEmail.vue"),
    DPE
},
  mixins: [getImage],
  data () {
    return {
      bien: {},
      d_image: '',
      photos: [],
      biensAnnexes: {}
    }
  },
  computed: {
    mailTo: function () {
      return encodeURI(`mailto:?subject=${this.bien.d_type} proposé par la société Tolus immo&body=Bonjour, voici un bien intéressant : ${window.location.href}`)
    }
  },
  props: {
    bienRecordId: String
  },
  methods: {
    async loadBien () {
      const options = {
        apiUrl: this.$apiUrl,
        databaseName: this.$databaseName,
        token: await this.$getMainToken()
      }
      const dataApi = new DataApi(options)
      dataApi.getRecord('W_AnnonceDetail', this.bienRecordId, [{ name: 'photos' }])
        .then((response) => {
          this.bien = response[0].fieldData
          const bienPhotosL = JSON.parse(JSON.stringify(response[0].portalData[Object.keys(response[0].portalData)]))
          if (bienPhotosL.length > 0) {
            this.insertBienPhotos(bienPhotosL)
          }
          const query = this.buildRequest()
          const sort = [
            {
              fieldName: 'd_prix',
              sortOrder: 'descend'
            },
            {
              fieldName: 'd_dateAnnonce',
              sortOrder: 'descend'
            }
          ]
          dataApi.findRecords('W_Annonce', query, sort, '', '3')
            .then((response) => {
              this.insertBiensAnnexes(response)
            })
        })
    },
    buildRequest () {
      const nbrPieces = parseInt(this.bien.d_nbrPieces * 0.8)
      const surface = parseInt(this.bien.d_surface * 0.8)
      const budget = parseInt(this.bien.d_prix * 0.8)
      const arrayFields = [
        { fieldname: 'd_type', fieldvalue: `==${this.bien.d_type}` },
        { fieldname: 'd_nbrPieces', fieldvalue: `>=${nbrPieces}` },
        { fieldname: 'd_surface', fieldvalue: `>=${surface}` },
        { fieldname: 'd_prix', fieldvalue: `>=${budget}` }
      ]
      const query = []
      query.push({ fields: arrayFields })
      return query
    },
    insertBienPhotos (bienPhotosL) {
      this.photos = []
      bienPhotosL.forEach(function (value, index) {
        const photo = Vue.removeLayout(value)
        this.getImage(photo.recordId)
          .then(res => {
            const ph = {}
            ph.d_image = res
            ph.d_imageAlt = photo.d_imageAlt
            this.photos.push(ph)
          })
      }, this)
    },
    insertBiensAnnexes (biensAnnexesL) {
      const biensAnnexesList = (biensAnnexesL === undefined) ? [] : biensAnnexesL
      if (biensAnnexesList.length > 0) {
        const biensToInsert = {}
        biensAnnexesList.forEach(function (value, index) {
          const dataToInsert = value.fieldData
          dataToInsert.recordId = value.recordId
          biensToInsert[index] = dataToInsert
        })
        this.biensAnnexes = biensToInsert
      } else {
        this.biensAnnexes = {}
      }
    },
    imprimer () {
      window.print()
    }
  },
  watch: {
    // call the method if the route changes
    $route: {
      handler: 'loadBien',
      immediate: true // runs immediately with mount() instead of calling method on mount hook
    }
  }
}
</script>

<style lang="scss" scoped>

#timeLineBar {
  li:nth-of-type(1):after,
  li:nth-of-type(2):after {
    content: '>';
    padding: 0 1rem !important;
    color: var(--secondary);
  }
}

.mainPicture {
  display: block !important;
  height: 35rem !important;
}

.articlePictures {
  height: 16vh;
  max-height: 11rem !important;
}

.infosLogo {
  li {
    display: flex !important;
    flex-direction: column;
    width: 19% !important;
    img {
      width: 5.4rem !important;
      height: 5.7rem !important;
      margin: 0 auto;
    }
    p {
      text-align: center;
      padding: 0 0.5rem;
      width: 100%;
    }
  }
}

.bien {
  img {
    width: 100% !important;
    height: 15rem !important;
  }
}

.calculate-card {
  height: 23rem !important;
  img {
    display: block;
    width: 4rem !important;
    height: 6rem !important;
  }
}

.prix {
  height: 3rem !important;
}

.picture {
  height: 11rem !important;
}

@media (min-width: 576px) {
  .bien {
    max-width: 30rem !important;
    width: 30% !important;
  }
}

.bandeau {
  transform: rotate(45deg);
}

.bandeau.sousOffre {
  top: 2rem;
  right: -2rem;
}

.bandeau.sousCompromis {
  top: 3rem;
  right: -2rem;
}

.bandeau.vendu {
  top: 0.8rem;
  right: -2rem;
}

.bandeau::after {
  padding: 0rem 2rem !important;
}

.bandeau.sousOffre::after {
  content: 'Sous offre';
  background-color: yellow;
  color: black !important;
}

.bandeau.sousCompromis::after {
  content: 'Sous compromis';
  background-color: orange;
  color: white !important;
}

.bandeau.vendu::after {
  content: 'Vendu';
  background-color: red;
  color: white !important;
}

@media ( max-width: 489px) {
  #timeLineBar {
    li:nth-of-type(1):after,
    li:nth-of-type(2):after {
      padding: 0 0.2rem !important;
    }
    button {
      width: 6rem !important;
    }
  }
  .infosLogo {
    li {
      img {
        width: 3.4rem !important;
        height: 3.7rem !important;
      }
      p {
        padding: 0 !important;
      }
    }
  }
}
.bgGreyPoints {
  background: url('../../assets/images/effet-points-3colonnes.svg') no-repeat right bottom;
  background-size: 100%;
  #buttonBar {
    button, a {
      ::v-deep .pictoArrow {
        fill: var(--secondary);
        height: 0.65rem;
      }
      ::v-deep .pictoAlert,
      ::v-deep .pictoPrint,
      ::v-deep .pictoNetwork {
        stroke: var(--secondary);
      }
    }
    button:hover, a:hover {
      ::v-deep .pictoArrow {
        fill: var(--light);
      }
      ::v-deep .pictoAlert,
      ::v-deep .pictoPrint,
      ::v-deep .pictoNetwork {
        stroke: var(--light);
      }
    }
  }
}
@media print {
  #timeLineBar,
  .bgGreyPoints,
  .btn
    {
    display:none !important;
  }
  #toPrint {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    padding-bottom: 350px;
  }
}
</style>
